import { PropsWithChildren } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ProLightGripLines } from '@nexelem/icons/ProLightGripLines';
import { IconButton } from '@nexelem/components';

type DndSortableQueueProps = {
  id: number;
};

export const DndSortableQueue = ({ id, children }: PropsWithChildren<DndSortableQueueProps>) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      className="mx-4 flex rounded-xs border border-border-secondary bg-surface-container-lighter has-[.hidden-queue]:border-border-container has-[.hidden-queue]:bg-surface-container"
      ref={setNodeRef}
      style={style}
    >
      <IconButton className="touch-none" Icon={ProLightGripLines} size="small" {...attributes} {...listeners} />
      {children}
    </div>
  );
};
